import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import moment from "moment";
import invoiceService from "../services/invoice-service";
import stockService from "../services/stock-service";
const GenerateInvoice = ({ history, totalMonths, parentsList, totalYears }) => {
  const [loading, setLoading] = useState(false);
  const { register, getValues } = useForm({});
  const [facList, setFacList] = useState([]);
  async function generateAllInvoice() {
    let massinvoice_month = getValues("mass_invoice_month");
    let massinvoice_year = getValues("mass_invoice_year");
    if (massinvoice_month !== "") {
      try {
        setLoading(true);
        let params = {
          year: massinvoice_year,
          month: massinvoice_month,
        };
        await invoiceService.generateInvoiceAll(params);
        setLoading(false);
        const { hide } = cogoToast.success(
          "Invoice Generating Succesfully.Soon you will get it in the Invoice List",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while generating invoice. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } else {
      const { hide } = cogoToast.error("Please Select Month", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  }
  async function generateInv() {
    let perParent = getValues("perParent");
    let perFacility = getValues("perFacility");
    let invoice_month_fac = getValues("invoice_month_fac");
    let invoice_year_fac = getValues("invoice_year_fac");
    if (perParent !== "" && invoice_month_fac !== "") {
      try {
        setLoading(true);
        let params = {
          payor: perParent,
          year: invoice_year_fac,
          group: perFacility,
          month: invoice_month_fac,
        };
        await invoiceService.generateInvPerParent(params);
        setLoading(false);
        const { hide } = cogoToast.success(
          "Invoice Generating Succesfully.Soon you will get it in the Invoice List",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while generating invoice. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } else {
      const { hide } = cogoToast.error("Please Select Parent & Month", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  }
  async function getFacilities(parentId) {
    if (parentId !== "") {
      try {
        setLoading(true);
        let resp = await stockService.getFacByParent(parentId);
        resp.sort((a, b) => a.name.localeCompare(b.name));
        setFacList(resp);
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while getting facilities details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  }
  const totalYearsList = () => {
    return totalYears().map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  };
  useEffect(() => {}, []);
  return (
    <div className="">
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div
        className={`inline-block w-full px-10 pb-4 border-b-2`}
      >
        <div className="text-left pt-3 pr-5 pb-4 ">
          <span className="text-darkclr font-semibold text-sm">
            Mass Generation Invoices
          </span>
        </div>
        <ul>
          <li className="inline-block text-xs leading-6 text-fontclr w-1/2">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Report Month
            </label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <select
              name="mass_invoice_month"
              aria-label="Select Report Month"
              ref={register({
                required: true,
              })}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
            >
              <option value="">Select Report Month</option>
              {totalMonths
                ? totalMonths.map((monthName, i) => {
                    return (
                      <option key={i} value={("0" + (i + 1)).slice(-2)}>
                        {monthName}
                      </option>
                    );
                  })
                : null}
            </select>
          </li>
          <li className="inline-block text-xs leading-6 text-fontclr w-1/2">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Report Year
            </label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <select
              name="mass_invoice_year"
              aria-label="Select Report Year"
              defaultValue={moment().year()}
              ref={register({
                required: false,
              })}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
            >
              {totalYearsList()}
            </select>
          </li>
          <li className="inline-block text-sm leading-4 w-full mb-4 mt-4">
            <input
              type="button"
              onClick={() => {
                generateAllInvoice();
              }}
              value="Generate Invoice"
              className="text-white w-full h-10 px-6 
              bg-header_bg rounded text-xs font-medium capitalize 
              focus:outline-none inline-block mr-4 cursor-pointer"
            />
          </li>
        </ul>
      </div>
      <div
        className={`inline-block w-full pt-5 px-10 pb-4 border-b-2`}
      >
        <div className="text-left pt-3 pr-5 pb-4 ">
          <span className="text-darkclr font-semibold text-sm">
            Generate Per Payor/Facility
          </span>
        </div>
        <ul>
          <li className="inline-block text-xs leading-6 text-fontclr w-1/2">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Parent
            </label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <select
              name="perParent"
              aria-label="Select Parent"
              ref={register({
                required: true,
              })}
              id="perParent"
              onChange={(e) => {
                getFacilities(e.target.value);
              }}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
            >
              <option value="">Select Parent</option>
              {parentsList
                ? parentsList.map((parent, i) => {
                    return (
                      <option key={i} value={parent}>
                        {parent}
                      </option>
                    );
                  })
                : null}
            </select>
          </li>
          <li className="inline-block text-xs leading-6 text-fontclr w-1/2">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Facility
            </label>
            <select
              name="perFacility"
              aria-label="Select Facility"
              ref={register({
                required: false,
              })}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
            >
              <option value="">Select Facility</option>
              {facList
                ? facList.map((facility, i) => {
                    return (
                      <option key={i} value={facility.code}>
                        {facility.name}
                      </option>
                    );
                  })
                : null}
            </select>
          </li>
          <li className="inline-block text-xs leading-6 text-fontclr w-1/2 my-4">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Report Month
            </label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <select
              name="invoice_month_fac"
              aria-label="Select Report Month"
              ref={register({
                required: true,
              })}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
            >
              <option value="">Select Report Month</option>
              {totalMonths
                ? totalMonths.map((monthName, i) => {
                    return (
                      <option key={i} value={("0" + (i + 1)).slice(-2)}>
                        {monthName}
                      </option>
                    );
                  })
                : null}
            </select>
          </li>
          <li className="inline-block text-xs leading-6 text-fontclr w-1/2">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Report Year
            </label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <select
              name="invoice_year_fac"
              aria-label="Select Report Year"
              defaultValue={moment().year()}
              ref={register({
                required: false,
              })}
              className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
            >
              {totalYearsList()}
            </select>
          </li>
          <li className="inline-block text-sm leading-8 w-full mb-4">
            <input
              type="button"
              onClick={() => {
                generateInv();
              }}
              value="Generate Invoice"
              className="text-white w-full h-10 px-6 
          bg-header_bg rounded text-xs font-medium capitalize 
          focus:outline-none inline-block mr-4 mt-4 cursor-pointer"
            />
          </li>
        </ul>
      </div>
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(GenerateInvoice)
);
